import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './layouts/DashboardLayout';
import LoginPage from './pages/auth/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import TherapistsPage from './pages/TherapistsPage';
import SystemHealthPage from './pages/SystemHealthPage';
import SettingsPage from './pages/SettingsPage';
import VerificationQueuePage from './pages/verifications/VerificationQueuePage';
import VerificationDetailPage from './pages/verifications/VerificationDetailPage';
import ExpirationsDashboard from './pages/ExpirationsDashboard';
import ReviewModerationPage from './pages/ReviewModerationPage';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected admin routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="therapists" element={<TherapistsPage />} />
          <Route path="expirations" element={<ExpirationsDashboard />} />
          <Route path="verifications" element={<VerificationQueuePage />} />
          <Route path="verifications/:id" element={<VerificationDetailPage />} />
          <Route path="reviews" element={<ReviewModerationPage />} />
          <Route path="system" element={<SystemHealthPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        {/* Catch all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
